module.exports = __webpack_public_path__ + "img/structuredDeposits1.effaad0a.jpg";